import { type FC } from 'react';

export interface CardContainerProps {
    cols?: '1' | '2' | '3' | '4' | '5' | '6';
    singleColumnOnTablet?: boolean;
    cardSpacing?: 'default' | 'wide';
    className?: string;
    children: React.ReactNode;
}

const CardContainer: FC<CardContainerProps> = ({
    className = '',
    children,
    cols = 3,
    singleColumnOnTablet,
    cardSpacing = 'default',
}) => {
    return (
        <div className={`card-container cols-${cols} card-spacing-${cardSpacing} ${singleColumnOnTablet ? 'cols-md-1' : ''} ${className}`}>
            {children}
        </div>
    );
};

export default CardContainer;
